import { memo, useMemo, FunctionComponent } from 'react';
import { Game, Game as GameType } from '~types';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import update from 'immutability-helper';
import { useApolloClient } from '@apollo/client';
import { useModal } from './hooks';
import { useConfig } from '~components/hooks';
import { GetName, SteamItemImage } from '../item';
import Currency from '../Currency';
import { Button, Price } from '~ui/index';
import GameChange from '../game/GameChange';
import { useKeyPressEvent } from 'react-use';

interface Props {
  id: number;
}

interface GetGameProps {
  getGame: GameType;
  onDelete: (props: Props) => void;
}

const GetGame: FunctionComponent<GetGameProps> = memo(
  ({ getGame, onDelete }) => {
    const { t } = useTranslation();
    const getConfig = useConfig();

    const onDone = () => {
      onDelete(getGame);
    };

    return (
      <div
        className={`in-case-item status-${getGame?.status}`}
        data-rar={getGame?.getItem?.color}
        data-status={getGame?.status}
        data-audio="5.wav"
        data-volume="0.4"
      >
        <div className="in-case-item-wrap">
          <div className="img">
            <div className="in-case-cost">
              <Price
                sum={
                  getGame?.status === 2 ? getGame?.priceSell : getGame?.price
                }
              />{' '}
              <Currency />
            </div>
            <SteamItemImage url={getGame?.getItem?.getImage} size="350x350" />
            <div className="honey"></div>
          </div>
          <div className="in-case-info">
            <div className="in-case-item-name">
              <GetName getItem={getGame?.getItem} type={0} />
            </div>
            <div className="in-case-item-desc">
              <GetName getItem={getGame?.getItem} type={1} />
            </div>

            <div className="in-case-info-btns">
              <GameChange
                className="btn btn-sell"
                onDone={onDone}
                getGame={getGame}
                type={0}
              >
                {getGame?.status === 1 && (
                  //Comment to hide +3% on sell SCRUM-151
                  <></>
                  // <div className="btn-sale-cost-wrap">
                  //   <div className="btn-sale-cost">
                  //     {getConfig.isEU ? (
                  //       <>
                  //         <Currency />
                  //         <Price sum={getGame?.price} />
                  //       </>
                  //     ) : (
                  //       <>
                  //         <Price sum={getGame?.price} />
                  //         <Currency />
                  //       </>
                  //     )}
                  //   </div>

                  //   <div className="btn-sale-cost percent">+3%</div>
                  // </div>
                )}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                >
                  <path
                    d="M1992,1385.667l16-16h-8V1367h13.333v13.333h-2.667v-8l-16,16Z"
                    transform="translate(-1981.333 -1356.333)"
                    fill="#fff"
                  ></path>
                </svg>
                <span className="text">
                  {getGame?.status === 1 ? t('Sell for') : t('Sold for')}
                </span>
                <div className="cost">
                  {getConfig.isEU ? (
                    <>
                      <Currency />
                      <Price sum={getGame?.priceSell} />
                    </>
                  ) : (
                    <>
                      <Price sum={getGame?.priceSell} />
                      <Currency />
                    </>
                  )}
                </div>
              </GameChange>
              {getGame?.status === 1 ? (
                <>
                  <Link className="btn-withdraw" to="/profile">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                    >
                      <g transform="translate(1611 1395) rotate(180)">
                        <g
                          transform="translate(1579 1363)"
                          fill="#fff"
                          stroke="#707070"
                          strokeWidth="1"
                          opacity="0"
                        >
                          <rect width="32" height="32" stroke="none"></rect>
                          <rect
                            x="0.5"
                            y="0.5"
                            width="31"
                            height="31"
                            fill="none"
                          ></rect>
                        </g>
                        <path
                          d="M1992,1381l12-12h-6v-2h10v10h-2v-6l-12,12Z"
                          transform="translate(-405 4)"
                          fill="#fff"
                        ></path>
                      </g>
                    </svg>
                    <span>{t('Withdraw')}</span>
                  </Link>
                  {/* <Link
                    className="btn-contracts"
                    to="/contract"
                    state={{ gameIds: [getGame?.id] }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                    >
                      <g transform="translate(1611 1395) rotate(180)">
                        <g
                          transform="translate(1579 1363)"
                          fill="#fff"
                          stroke="#707070"
                          strokeWidth="1"
                          opacity="0"
                        >
                          <rect width="32" height="32" stroke="none"></rect>
                          <rect
                            x="0.5"
                            y="0.5"
                            width="31"
                            height="31"
                            fill="none"
                          ></rect>
                        </g>
                        <path
                          d="M-64,4478h-2v-2a9.871,9.871,0,0,1-6.2-2.8A9.869,9.869,0,0,1-75,4467h-2v-2h2a9.869,9.869,0,0,1,2.8-6.2A9.875,9.875,0,0,1-66,4456v-2h2v2a9.876,9.876,0,0,1,6.2,2.8A9.868,9.868,0,0,1-55,4465h2v2h-2a9.872,9.872,0,0,1-2.8,6.2A9.876,9.876,0,0,1-64,4476v2Zm0-5v1a7.509,7.509,0,0,0,7-7h-1v-2h1a7.51,7.51,0,0,0-7-7v1h-2v-1a7.507,7.507,0,0,0-7,7h1v2h-1a7.5,7.5,0,0,0,7,7v-1Zm-1-2a5.2,5.2,0,0,1-5-5,5.2,5.2,0,0,1,5-5,5.2,5.2,0,0,1,5,5A5.2,5.2,0,0,1-65,4471Zm0-8a3,3,0,0,0-3,3,3,3,0,0,0,3,3,3,3,0,0,0,3-3A3,3,0,0,0-65,4463Z"
                          transform="translate(1660 -3087)"
                          fill="#fff"
                          stroke="rgba(0,0,0,0)"
                          strokeMiterlimit="10"
                          strokeWidth="1"
                        ></path>
                      </g>
                    </svg>
                    <span>{t('Add to the contract')}</span>
                  </Link> */}
                </>
              ) : (
                <Link className="btn-home" to="/profile">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                  >
                    <g transform="translate(42.333 42.333) rotate(180)">
                      <path
                        d="M16.5-23.5h6a2.557,2.557,0,0,0-1-2,2.63,2.63,0,0,0-2-1,2.63,2.63,0,0,0-2,1A2.557,2.557,0,0,0,16.5-23.5Zm14-1,5,4h-5v14h-8v-10h-6v10h-8v-14h-5l16-14,6,5v-4h5Z"
                        transform="translate(40.333 1.333) rotate(180)"
                        fill="#4b69ff"
                      ></path>
                    </g>
                  </svg>
                  <span>{t('Inventory')}</span>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  },
);

GetGame.displayName = 'GetGame';

const WinItemsModal: FunctionComponent = () => {
  const client = useApolloClient();
  const modalName = 'WinItemsModal';
  const { t } = useTranslation();
  const getConfig = useConfig();
  const { onClose, isOpen, props, updateProps } = useModal<{
    getGames: Game[];
  }>(modalName);
  const getGames = _.toArray(props?.getGames) as GameType[];

  const onDelete = ({ id }) => {
    const index = _.findIndex(getGames, getGame => getGame.id === id);

    updateProps({
      getGames: update(getGames, { [index]: { status: { $set: 2 } } }),
    });
  };

  useKeyPressEvent(
    ({ code }) => code === 'KeyS',
    () => {
      const button = document.querySelector(
        'button[data-event="onSellAllItem"]',
      );

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  const onDone = () => {
    updateProps({
      getGames: _.map(getGames, getGame => {
        client.cache.modify({
          id: `Game:${getGame.id}`,
          fields: {
            status() {
              return 2;
            },
            getStatus() {
              return t('Sold');
            },
          },
        });

        return {
          ...getGame,
          status: 2,
        };
      }),
    });
  };

  const filterGames = useMemo(
    () => _.filter(getGames, getGame => getGame.status === 1),
    [getGames],
  );
  const sumPrice = useMemo(() => _.sumBy(filterGames, 'price'), [filterGames]);
  const sumPriceSell = useMemo(
    () => _.sumBy(filterGames, 'priceSell'),
    [filterGames],
  );
  const gameIds = useMemo(() => _.map(filterGames, 'id'), [filterGames]);

  return (
    <Modal show={isOpen} onClose={onClose} width={560} modalName={modalName}>
      <div className="box-modal-wrap" id="won">
        <div className="box-modal">
          <div
            className="box-modal_close arcticmodal-close"
            onClick={onClose}
          ></div>
          <div className="box-modal-won">
            <div className="won-title">{t('Your prize')}:</div>
            <div className="items">
              {getGames.map(getGame => (
                <GetGame
                  key={getGame.id}
                  getGame={getGame}
                  onDelete={onDelete}
                />
              ))}
            </div>

            <div className="won-footer">
              <div className="case-play-win-btns">
                {filterGames.length > 0 && (
                  <GameChange
                    className="btn btn-sell"
                    gameIds={gameIds}
                    type={2}
                    onDone={onDone}
                    sumPriceSell={sumPriceSell}
                    sumPrice={sumPrice}
                    data-event="onSellAllItem"
                  >
                    <div className="btn-hoykey">s</div>
                    {/*//Comment to hide +3% on sell SCRUM-151 */}
                    {/* <div className="btn-sale-cost-wrap">
                      <div className="btn-sale-cost">
                        {getConfig.isEU ? (
                          <>
                            <Currency />
                            <Price sum={sumPrice} />
                          </>
                        ) : (
                          <>
                            <Price sum={sumPrice} />
                            <Currency />
                          </>
                        )}
                      </div>

                      <div className="btn-sale-cost percent">+3%</div>
                    </div> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                    >
                      <path
                        d="M1992,1385.667l16-16h-8V1367h13.333v13.333h-2.667v-8l-16,16Z"
                        transform="translate(-1981.333 -1356.333)"
                        fill="#fff"
                      ></path>
                    </svg>
                    <span className="text">{t('Sell all for')}</span>
                    <div className="cost">
                      {getConfig.isEU ? (
                          <>
                            <Currency />
                            <Price sum={sumPriceSell} />
                          </>
                        ) : (
                          <>
                            <Price sum={sumPriceSell} />
                            <Currency />
                          </>
                        )}
                    </div>
                  </GameChange>
                )}

                {/* {filterGames.length > 0 && (
                  <Link
                    className="btn-back btn-contracts"
                    to={{ pathname: '/contract' }}
                    state={{ gameIds }}
                    data-event="goContract"
                  >
                    <div className="btn-hoykey">c</div>
                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                      >
                        <path
                          d="M17.334,32H14.667V29.334A13.162,13.162,0,0,1,6.4,25.6a13.157,13.157,0,0,1-3.737-8.264H0V14.667H2.667A13.16,13.16,0,0,1,6.4,6.4a13.167,13.167,0,0,1,8.262-3.737V0h2.667V2.666A13.167,13.167,0,0,1,25.6,6.4a13.158,13.158,0,0,1,3.736,8.264H32v2.666H29.333A13.162,13.162,0,0,1,25.6,25.6a13.167,13.167,0,0,1-8.264,3.738V32Zm0-6.666v1.332a10.011,10.011,0,0,0,9.334-9.334H25.334V14.667h1.334a10.013,10.013,0,0,0-9.334-9.333V6.666H14.667V5.333a10.009,10.009,0,0,0-9.332,9.333H6.667v2.666H5.337a10,10,0,0,0,9.329,9.334V25.336ZM16,22.667A6.93,6.93,0,0,1,9.334,16,6.93,6.93,0,0,1,16,9.334,6.93,6.93,0,0,1,22.667,16,6.93,6.93,0,0,1,16,22.667ZM16,12a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                          transform="translate(5.333 5.333)"
                          fill="#fff"
                          stroke="rgba(0,0,0,0)"
                          strokeMiterlimit="10"
                          strokeWidth="1"
                        ></path>
                      </svg>
                    </div>
                    <span>{t('Add to the contract')}</span>
                  </Link>
                )} */}
                <Button
                  className="btn-back"
                  onClick={onClose}
                  data-event="onPlayAgain"
                >
                  <div className="btn-hoykey">r</div>
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                    >
                      <rect
                        width="42"
                        height="42"
                        transform="translate(0.333 0.333)"
                        fill="#4b69ff"
                        opacity="0"
                      ></rect>
                      <path
                        d="M-1.133-13.7v-5l5,7-5,6v-5c-8.993-.108-12.951-5.877-13-12a13.062,13.062,0,0,1,2-7l2,3a7.438,7.438,0,0,0-1,4c0,2.572,1.18,4.18,3,6A10.188,10.188,0,0,0-1.133-13.7Zm0-22c7.826-.231,12,6.07,12,13a9.913,9.913,0,0,1-2,6l-2-3c.728-1.31,1-1.4,1-3a10.188,10.188,0,0,0-3-7c-1.82-1.82-3.428-3-6-3v5l-6-7,6-6Z"
                        transform="translate(19.7 -1.863) rotate(180)"
                        fill="#4b69ff"
                      ></path>
                    </svg>
                  </div>
                  <span>{t('return_to_case')}</span>
                </Button>
                <Link
                  className="btn-back btn-home"
                  to="/profile"
                  data-event="goProfile"
                >
                  <div className="btn-hoykey">i</div>
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                    >
                      <g transform="translate(42.333 42.333) rotate(180)">
                        <path
                          d="M16.5-23.5h6a2.557,2.557,0,0,0-1-2,2.63,2.63,0,0,0-2-1,2.63,2.63,0,0,0-2,1A2.557,2.557,0,0,0,16.5-23.5Zm14-1,5,4h-5v14h-8v-10h-6v10h-8v-14h-5l16-14,6,5v-4h5Z"
                          transform="translate(40.333 1.333) rotate(180)"
                          fill="rgba(75,105,255,0.5)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <span>{t('Inventory')}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WinItemsModal;
